module.exports = __webpack_public_path__ + "img/toast2.4d471e51.png";